import { Directive, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { debounceTime } from 'rxjs/operators';

/** Difference between ui-cake-counter and ui-single-pieces-counter:
 * ui-cake-counter is used in cake-builder footer, when cake-builder first init it should have some quantity
 * for product (it maybe increment or minQuantity) it is made for user usability,
 * it is better when user don't start with zero product quantity, while ui-single-pieces-counter is used on products overview
 * and in cake-multiple-variant-section where products quantity should be start with zero value, that's why
 * shiftCount and control disable logic a bit different
 * */

@Directive({ standalone: false })
export class UiCakeCounterBaseComponent extends CustomComponent implements OnInit {
  @Input() minCountPerProduct = 0;
  @Input() minCount = 1;
  @Input() maxCount: number | null = null;
  @Input() step = 1;
  @Input() count: number;
  @Input() size = 'lg';
  @Input() btnStyle = 'btn-primary';
  @Input() isMinusDisabled: boolean;
  @Input() isPlusDisabled: boolean;
  @Input() isAllowEnterCounter = true;
  @Input() debounceTimeCount = 600;
  @Input() btnHighlighting = false;
  @Input() extraCount = 0;

  @Output() onCountUpdated = new EventEmitter<number>();

  public positiveNumberPattern = /^\+?([0-9]\d*)$/;
  public manualInput$ = new Subject<number>();

  ngOnInit() {
    if (this.isAllowEnterCounter) {
      this._subscribe();
    }
  }

  public plusDisablingCheck() {
    return this._hasMaxCount() && this.count >= this.maxCount;
  }

  public minusDisablingCheck() {
    return this.count === 0;
  }

  public setCount(newCount) {
    this.onCountUpdated.emit(newCount);
  }

  public updateManualInputCount(count: number) {
    this.count = count < this.minCount ? this.minCount : count;
    if (this._hasMaxCount() && this.maxCount < count) {
      this.count = this.maxCount;
    }
    this.setCount(this.count);
  }

  public inputCounterChanged(count) {
    this.count = count;
    this.manualInput$.next(+count);
  }

  protected _subscribe() {
    this.addSubscriber(
      this.manualInput$.pipe(debounceTime(this.debounceTimeCount))
        .subscribe((count: number) => this.updateManualInputCount(count))
    );
  }

  protected _getShift(isIncrease: boolean): number {
    const minCount = this.minCountPerProduct || this.minCount;

    if (isIncrease) {
      return this.count === 0 ? minCount || this.step : this.step;
    }
    return -(this.count === minCount ? minCount : this.step);
  }

  // 0 was being used as “no max”, but with stock logic 0 can be a real maximum: out of stock
  protected _hasMaxCount(): boolean {
    return this.maxCount !== null;
  }
}
